import { render, staticRenderFns } from "./checkBlockInfo.vue?vue&type=template&id=57e5bad9&scoped=true&"
import script from "./checkBlockInfo.vue?vue&type=script&lang=js&"
export * from "./checkBlockInfo.vue?vue&type=script&lang=js&"
import style0 from "./checkBlockInfo.vue?vue&type=style&index=0&id=57e5bad9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e5bad9",
  null
  
)

export default component.exports